declare global {
  interface Window {
    DocumentTouch: () => unknown;
  }
}

export function isTouchableDevice(): boolean {
  return (
    !!(
      typeof window !== 'undefined' &&
      ('ontouchstart' in window ||
        (window.DocumentTouch &&
          typeof document !== 'undefined' &&
          document instanceof window.DocumentTouch))
    ) ||
    !!(
      typeof navigator !== 'undefined' &&
      (navigator.maxTouchPoints || 'msMaxTouchPoints' in navigator)
    )
  );
}

export function redirect(path: string): void {
  window.location.href = path;
}

export function getCurrentOrigin(): string {
  return window.location.origin;
}

export function getCurrentQuery(): string {
  return window.location.search;
}

export type ScreenSize = 'mobileWidth' | 'tabletWidth' | 'desktopWidth';

const MOBILE_MAX_WIDTH = 600;
const TABLET_MAX_WIDTH = 900;

export function getScreenSize(): ScreenSize {
  if (window.innerWidth < MOBILE_MAX_WIDTH) {
    return 'mobileWidth';
  }
  if (window.innerWidth < TABLET_MAX_WIDTH) {
    return 'tabletWidth';
  }
  return 'desktopWidth';
}

export function reloadPage(extraParameters?: URLSearchParams): void {
  if (extraParameters) {
    const currentURL = new URL(window.location.href);

    for (const [key, value] of extraParameters) {
      currentURL.searchParams.append(key, value);
    }

    redirect(currentURL.href);
  } else {
    window.location.reload();
  }
}
